/**
 * Opt-in de notificaciones push del panel del promotor.
 *
 * Cablea el helper genérico (shared/services/push-opt-in.js) con el ApiClient del
 * promoter (auth x-admin-token) y el SW del front. El backend entrega los avisos
 * (pago recibido, etc.) por Web Push — ver backend/src/services/push/.
 */
import ApiClient from './api-client.js';
import { activarPush, estadoPermiso, pushSoportado, esIOS, esStandalone } from '@shared/services/push-opt-in.js';
import { registrarServiceWorker as registrarCicloDeVidaSw } from '@shared/service-worker/core/registro-cliente.js';

const SW_URL = '/sw.js';

/**
 * Activa las notificaciones del promotor. Devuelve el resultado para que la UI
 * muestre el mensaje adecuado (activado / denegado / iOS-requiere-instalar / etc.).
 */
export async function activarNotificaciones() {
    return activarPush({
        swUrl: SW_URL,
        getVapidPublicKey: async () => {
            const res = await ApiClient.get('/api/cashier/push/vapid-public-key');
            return res && res.ok ? res.vapidPublicKey : null;
        },
        postSubscription: async subJson => {
            // subJson = { endpoint, keys:{p256dh,auth}, ... } (lo que produce el navegador).
            return ApiClient.post('/api/cashier/push/subscribe', subJson);
        },
    });
}

/**
 * Registra el SW al boot (sin pedir permiso — eso es por gesto del usuario). Así el
 * SW está listo para cuando el promotor active las notificaciones, y para el cache.
 *
 * Delegado al módulo compartido (SSOT shared/service-worker/SPEC.md), que además
 * del register trae el ciclo de vida completo: update() inmediato/online/polling
 * + reload con guard anti-loop. Antes esta función SOLO registraba — el sw.js
 * emitía RELOAD_REQUIRED y nadie escuchaba: un rebuild jamás se recuperaba solo.
 */
export function registrarServiceWorker() {
    registrarCicloDeVidaSw({
        swUrl: SW_URL,
        politicaUpdate: 'reload-agresivo',
        storageKeyGuard: 'promoter_reload_required_count',
    });
}

// Re-export de los helpers de estado para que la UI decida qué mostrar.
export { estadoPermiso, pushSoportado, esIOS, esStandalone };
